import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';
import { ActivityDomainViewModel, ActivityProductCategoryViewModel } from '../../models/activity-model';

@Injectable({
    providedIn: 'root'
})
export class ActivityDomainService extends ApiServiceBase {
    private readonly PATH = "/activity/activitydomains"

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getAll(): Observable<ActivityDomainViewModel[]> {
        return this.httpGet<ActivityDomainViewModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }

    public getActivityProductCategory(): Observable<ActivityProductCategoryViewModel[]> {
        return this.httpGet<ActivityProductCategoryViewModel[]>(this.PATH + '/productcategory', null)
            .pipe(
                map(res => res.body)
            )
    }
}